<template>
  <div class="relative mx-4 max-w-screen-xl md:mx-10 xl:mx-auto xl:px-4">
    <slot />
  </div>
</template>
